import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams, type OpenCreditPackModalLocations } from '../types';
import META from './useTrackCreditPackModalOpened.meta';

export type UseTrackCreditPackModalOpenedParams = CreditAnalyticsParams & {
  source?: Exclude<OpenCreditPackModalLocations, 'checkout'>;
};

export const useTrackCreditPackModalOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditPackModalOpened = useCallback(
    (params: UseTrackCreditPackModalOpenedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditPackModalOpened };
};
